<template>
  <qc-dialog
    class="tc-15-rich-dialog cos"
    :show="innerShow"
    type="custom"
    :title="$t('core.file_preview')"
    :default-cancel="false"
    :width="720"
    @close="closeDialog"
    :closeTriggers="['esc']"
  >
    <div class="preview-wrap mb-20">
      <div class="preview">
        <div class="preview-inner" v-if="loading">
          <qc-icon type="loading"></qc-icon>
        </div>
        <div class="preview-inner" v-else-if="errorMessage">
          <p class="error-message">{{ errorMessage }}</p>
          <p class="preview-title">{{ name }}</p>
        </div>
        <div class="preview-inner" v-else>
          <img
            v-if="type === 'image'"
            class="preview-image"
            @load="onMediaLoad"
            :src="url"
            :alt="name"
            @error="onError"
          />
          <video
            v-else-if="type === 'video'"
            class="preview-video"
            controls
            :src="url"
            @canplay="onMediaLoad"
            @error="onError"
          ></video>
          <audio v-else-if="type === 'audio'" class="preview-audio" controls :src="url"></audio>
          <p class="preview-title">{{ name }}</p>
        </div>
      </div>
      <div class="toolbar">
        <a href="javascript:void(0)" @click="copyLink">{{ $t('core.copy_link') }}</a>
        <a href="javascript:void(0)" @click="downloadFile">{{ $t('core.download') }}</a>
        <a href="javascript:void(0)" class="preview-qrlink">
          {{ $t('core.view_on_phone') }}
          <qrcode-vue class="preview-qrcode" :value="url" size="200"></qrcode-vue>
        </a>
      </div>
      <div class="prev" :class="{ disabled: index === 0 }" @click="prev"></div>
      <div class="next" :class="{ disabled: index === list.length - 1 }" @click="next"></div>
    </div>
  </qc-dialog>
</template>

<script>
import qrcodeVue from '@/components//common/qrcode.vue';

import eventProxy from '@/scripts/tools/eventProxy';
import cos from '@/scripts/helper/cos/index';

export default {
  components: {
    qrcodeVue,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      name: '',
      mediaShow: false,
      loading: false,
      errorMessage: '',
      paddingTop: 0,
      url: '',
      index: 0,
      type: 'image',
      list: [],
    };
  },
  computed: {
    innerShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      },
    },
  },
  mounted() {
    eventProxy.on('preview.show', this.onPreview);
  },
  destroyed() {
    eventProxy.on('preview.show', this.onPreview);
  },
  methods: {
    async loadMedia() {
      const url = await cos.getDownloadUrl(this.list[this.index].url);
      const setUrl = async () => {
        const simpleUrl = url.split('?')[0];
        const itemSimpleUrl = await cos.getDownloadUrl(this.list[this.index].url);
        if (simpleUrl !== itemSimpleUrl.split('?')[0]) {
          return;
        }
        this.url = url;
        this.errorMessage = '';
        this.name = decodeURIComponent(this.url.replace(/[#?].*$/, '').replace(/^.*\//, ''));

        this.loading = false;
      };
      if (this.type === 'image') {
        const img = new Image();
        img.onload = setUrl;
        img.onerror = setUrl;
        img.src = url;
      } else {
        setUrl();
      }
    },
    onPreview(data) {
      this.innerShow = true;
      if (!data) {
        this.loading = true;
        return;
      }
      data.list.some((v, index) => {
        if (data.url === v.url) {
          this.index = index;
          return true;
        }
        return false;
      });
      this.list = data.list;
      this.type = data.type;
      this.loadMedia();
    },
    copyLink() {
      this.$emit('copy', this.list[this.index]);
    },
    downloadFile() {
      this.$emit('download', [this.list[this.index]]);
    },
    prev() {
      this.slice(-1);
    },
    next() {
      this.slice(1);
    },
    slice(offset) {
      this.loading = true;
      this.index = Math.min(this.list.length - 1, Math.max(0, this.index + offset));
      this.loadMedia();
    },
    onMediaLoad(e) {
      const paddingTop = Math.max(0,
        (e.target.parentNode.parentNode.offsetHeight - 30 - e.target.offsetHeight) / 2 - 20);
      this.paddingTop = `${paddingTop}px`;
      this.loading = false;
      this.mediaShow = true;
    },
    onError() {
      if (this.loading) return;
      this.errorMessage = window.lang.t('error.preview_err');
    },
    closeDialog() {
      this.innerShow = false;
    },
  },
};
</script>

<style scoped>
.preview-wrap {
  position: relative;
  height: 450px;
}
.preview {
  box-sizing: border-box;
  text-align: center;
  vertical-align: middle;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 409px;
}
.preview-title {
  padding-bottom: 10px;
  text-align: center;
}
.preview-inner {
  width: 100%;
}
.preview-image,
.preview-video {
  margin: 0 auto;
  max-width: 100%;
  max-height: 372px;
  -webkit-user-drag: none;
  outline: 1px solid #eee;
}
.preview-audio {
  margin-top: 58px;
  margin-bottom: 20px;
  width: 80%;
}
.error-message {
  font-size: 14px;
  color: red;
  text-align: center;
}
.toolbar {
  margin-top: 20px;
  text-align: center;
}
.toolbar a {
  margin-right: 5px;
}
.preview-qrlink {
  position: relative;
}
.preview-qrlink .preview-qrcode {
  display: none;
  position: absolute;
  padding: 10px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
  bottom: 36px;
  left: -80px;
  font-size: 0;
  height: 200px;
}
.preview-qrlink .preview-qrcode:after {
  display: block;
  content: ' ';
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.27);
  background: #fff;
  height: 11px;
  width: 11px;
  transform: rotate(45deg);
  position: absolute;
  bottom: -6px;
  left: 103px;
}
.preview-qrlink:hover .preview-qrcode {
  display: block;
}
.prev,
.next {
  position: absolute;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  line-height: 48px;
  font-size: 24px;
  top: 50%;
  margin-top: -50px;
  background: rgba(0, 0, 0, 0.25);
  text-align: center;
  vertical-align: middle;
  color: #fff;
  font-family: sans-serif;
  cursor: pointer;
}
.prev:hover,
.next:hover {
  background: rgba(0, 0, 0, 0.3);
}
.prev:active,
.next:active {
  background: rgba(0, 0, 0, 0.35);
}
.prev.disabled,
.next.disabled {
  display: none;
  background: rgba(0, 0, 0, 0.1) !important;
  cursor: not-allowed;
}
.prev {
  left: 0;
}
.next {
  right: 0;
}
.prev:after,
.next:after {
  display: inline-block;
  border-top: 3px solid #fff;
  border-left: 3px solid #fff;
  width: 10px;
  height: 10px;
}
.prev:after {
  content: ' ';
  transform: rotate(-45deg);
  margin-left: 4px;
}
.next:after {
  content: ' ';
  transform: rotate(135deg);
  margin-right: 4px;
}
</style>
